import React from 'react'
import { Link } from 'react-router-dom'

import { ChargePoint } from '../../../common/redux/api/web-api'
import Text from '../../../ui/Text'
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableBodyCell } from '../../../lib/table'
import { STableLink } from '../../../lib/table/Table.styles'
import { WidgetLayout } from '../../../lib/widget-layout'

export type UserRegisteredToChargersWidgetProps = {
    registeredChargePoints: ChargePoint[]
    dataLoadingOwnedChargePoints: boolean
    style?: React.CSSProperties
}

export function UserRegisteredToChargersWidget({
    style,
    registeredChargePoints,
    dataLoadingOwnedChargePoints,
}: UserRegisteredToChargersWidgetProps): React.ReactElement {
    return (
        <WidgetLayout
            loadingStatus={dataLoadingOwnedChargePoints}
            title={<Text code="lblRegisteredToChargers" />}
            style={style}
            data-testid="registered-to-chargers"
        >
            <Table data-testid="registered-chargers">
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell data-testid="lbl-id">
                            <Text code="lblId" />
                        </TableHeaderCell>
                        <TableHeaderCell data-testid="lbl-name">
                            <Text code="lblName" />
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {registeredChargePoints?.map((c, i) => (
                        <TableRow key={i} data-testid={`row-${i}`}>
                            <TableBodyCell data-testid={`charger-id-${i}`}>
                                <STableLink as={Link} to={`/chargepoints/${c.id}`}>
                                    {c.id}
                                </STableLink>
                            </TableBodyCell>
                            <TableBodyCell data-testid={`charger-name-${i}`}>{c.name}</TableBodyCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </WidgetLayout>
    )
}
